import { create } from 'zustand';
import type { Role } from '@/types/auth';

interface AuthState {
  role: Role;
  viewRole: Role | null;
  userId: string | null;
  email: string | null;
  phone: string | null;
  approved: boolean;

  setUser: (data: { role: Role; userId: string; email: string | null; phone: string | null; approved: boolean }) => void;
  toggleViewRole: () => void;
  getEffectiveRole: () => Role;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  role: 'user',
  viewRole: null,
  userId: null,
  email: null,
  phone: null,
  approved: false,

  setUser: (data) => set({
    role: data.role,
    viewRole: data.role === 'admin' ? 'admin' : null,
    userId: data.userId,
    email: data.email,
    phone: data.phone,
    approved: data.approved,
  }),

  toggleViewRole: () => {
    const { viewRole } = get();
    set({ viewRole: viewRole === 'admin' ? 'user' : 'admin' });
  },

  getEffectiveRole: () => {
    const { viewRole, role } = get();
    return viewRole || role;
  },

  isAdmin: () => get().getEffectiveRole() === 'admin',
}));
